<template>
  <div>
    <div class="c-location-modal">
      <aha-modal
        id="ahaZipCodeModal"
        ref="ahaZipCodeModal"
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        size="lg"
        hide-footer
        centered
        lazy
      >
        <b-container fluid>
          <div class="c-listing-header c-listing-header--medium pt-0">
            <div class="c-listing-header__cta-container d-block">
              <h2 class="c-listing-header__heading">{{translations.heading}}</h2>
            </div>
          </div>
          <p class="c-listing-header__subheading">{{translations.subheading}}</p>
          <br />
          <div>
            <form action="#" method="post" v-on:submit.prevent="onSubmit">
              <div class="form-group">
                <label for="event_manual_zipcode" class="text-left">
                  Zip code (required)
                  <p class="invalid-feedback">Please provide a valid zipcode.</p>
                </label>
                <input
                  id="event_manual_zipcode"
                  type="text"
                  pattern="^\d{5}(?:[-\s]\d{4})?$"
                  name="manualZipcodeEntry"
                  class="form-control"
                  placeholder="Please enter your zip code"
                  aria-required="true"
                  required
                  aria-invalid="false"
                  v-model="zipcode"
                />
              </div>
              <input type="submit" :value="translations.btn" class="btn btn-primary btn-round" />
            </form>
          </div>
        </b-container>
      </aha-modal>
    </div>
  </div>
</template>

<script>
import { Cookie } from "@/utils/aha-cookie";
export default {
  data() {
    return {
      zipcode: "",
      isVisible: false
    };
  },
  props: {
    translations: {
      type: Object,
      required: true,
      default: {
        cookie: "",
        btn: "Search",
        heading: "",
        subheading: ""
      }
    },
    zipCodeSelector: {
      type: String,
      default: ""
    }
  },
  mounted() {
    Cookie.getAllCookies(); //Show all cookies
    if (Cookie.cookieExist(this.translations.cookie) === false) {
      this.showModal();
    }
  },
  methods: {
    handleClose() {
      this.$root.$emit("bv::hide::modal", "ahaZipCodeModal");
    },
    hideModal() {
      this.$refs.ahaZipCodeModal.hide();
    },
    onShown() {
      this.isVisible = true;
    },
    onHidden() {
      this.isVisible = false;
    },
    onSubmit() {
      Cookie.setCookie(this.translations.cookie, this.zipcode);
      this.handleClose();
      console.log(this.zipcode);
      document.getElementById(
        this.zipCodeSelector
      ).value = Cookie.getCookieValue(this.translations.cookie);
      document.getElementById(this.zipCodeSelector).scrollIntoView();
      document.getElementById(this.zipCodeSelector).focus();
    },
    showModal() {
      this.$refs.ahaZipCodeModal.show();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/app/components/aha-hospital-zipcode-modal.vue